import useI18nGlobal from '@/utils/i18n';
const {i18n} = useI18nGlobal();
const {t} = i18n.global;
export const CONTENT_BAR_OPTIONS = [
  {value: 'popup-small', popup: 'detached_small', get name() { return t('options.contentBar.detachedSmall')}},
  {value: 'popup-medium', popup: 'detached_medium', get name() { return t('options.contentBar.detachedMedium')}},
  {value: 'popup', popup: 'detached', get name() { return t('options.contentBar.detachedLarge')}},
  {value: 'popup-panel', popup: 'small', get name() { return t('options.contentBar.panelSmall')}},
  {value: 'popup-panel-large', popup: 'large', get name() { return t('options.contentBar.panelLarge')}}
]